import { FC } from 'react';
import { RouterProvider } from 'react-router-dom';

import SnackbarStack from './ui/tools/SnackbarStack';
import useAxiosAuthSetup from './hooks/requests/useAxiosAuthSetup.ts';
import { axiosAuthInstance, axiosInstance } from './api';
import useRouter from './router';
import useAxiosCaptchaSetup from './hooks/requests/useAxiosCaptchaSetup.ts';

const App: FC = () => {
  const router = useRouter();

  useAxiosAuthSetup(axiosAuthInstance);
  useAxiosCaptchaSetup(axiosInstance);

  return (
    <>
      <RouterProvider router={router} />

      <SnackbarStack />
    </>
  );
};

export default App;
